import React from "react";
import TitleFormat from "../../../components/TitleFormat";
import ItDecarbonizationContent from "../../../components/ItDecarbonizationContent";
import ItCarbonNeutralCity from "../../../components/ItCarbonNeutralCity";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const ItDecarbonization = () => {
  const { t } = useTranslation();
  const title = { text: `${t("it.decarbonization.title")}`, path: "", width: 800 };
  return (
    <>
      <Seo title={t("it.decarbonization.seo.title")} description={t("it.decarbonization.seo.des")} path="esg-rnd/decarbonization" />
      <TitleFormat text={title.text} />
      <ItDecarbonizationContent />
      <ItCarbonNeutralCity />
    </>
  );
};

export default ItDecarbonization;
